import React from "react";

export const MiBoardDialog: React.FC<{
  title: string;
  children: React.ReactNode;
  actions: React.ReactNode;
  onClose: () => void;
}> = ({ title, children, actions, onClose }) => (
  <div
    aria-modal="true"
    role="dialog"
    aria-labelledby="miboard-dialog-title"
    onMouseDown={onClose}
    style={{
      alignItems: "center",
      background: "rgba(12, 28, 36, 0.48)",
      display: "flex",
      inset: 0,
      justifyContent: "center",
      padding: 20,
      position: "fixed",
      zIndex: 1000,
    }}
  >
    <section
      onMouseDown={(event) => event.stopPropagation()}
      style={{
        background: "#ffffff",
        borderRadius: 16,
        boxShadow: "0 24px 60px rgba(9, 39, 51, 0.28)",
        maxHeight: "calc(100vh - 40px)",
        maxWidth: 760,
        overflowY: "auto",
        padding: 28,
        width: "min(100%, 760px)",
      }}
    >
      <h2 id="miboard-dialog-title" style={{ margin: "0 0 12px" }}>
        {title}
      </h2>
      <div>{children}</div>
      <div
        style={{
          display: "flex",
          gap: 12,
          justifyContent: "flex-end",
          marginTop: 24,
        }}
      >
        {actions}
      </div>
    </section>
  </div>
);
